import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { OnboardingState } from './useOnboardingState';

interface BusinessProfileProps {
  userId: string | null;
  isInitialized: boolean;
  businessProfileCompleted: boolean;
  saveOnboardingState: (newState: Partial<OnboardingState>) => void;
}

export const useBusinessProfileValidation = ({
  userId,
  isInitialized,
  businessProfileCompleted,
  saveOnboardingState
}: BusinessProfileProps) => {
  
  useEffect(() => {
    if (!userId || !isInitialized) return;
    
    const checkBusinessProfile = async () => {
      // Check the profiles table which contains business info
      const { data: profileData, error } = await supabase
        .from('profiles')
        .select('business_name, street_address, city, state, zip_code')
        .eq('id', userId)
        .single();
      
      if (!error && profileData) {
        const isComplete = !!profileData.business_name && 
                          !!profileData.street_address &&
                          !!profileData.city &&
                          !!profileData.state &&
                          !!profileData.zip_code;
        
        if (isComplete !== businessProfileCompleted) {
          saveOnboardingState({ businessProfileCompleted: isComplete });
        }
      }
    };
    
    checkBusinessProfile();
    
    const handleBusinessProfileUpdate = () => {
      checkBusinessProfile();
    };
    
    const handleHashChange = () => {
      if (window.location.hash.includes('refresh-')) {
        checkBusinessProfile();
      }
    };
    
    document.addEventListener('business-profile-updated', handleBusinessProfileUpdate);
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      document.removeEventListener('business-profile-updated', handleBusinessProfileUpdate);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [userId, isInitialized, businessProfileCompleted, saveOnboardingState]);
};
